/* VINOD collection: in-stock first + infinite scroll (v2.1)
 * Uses the normal ?page=N pages (no filter URLs needed).
 * Pages are fetched in the background in order. In-stock cards are shown as they arrive;
 * sold-out cards are held back and appended only after the last page.
 * Keeps the current sort_by and any other URL params. Dedupes by product handle.
 * Debug: add ?vdcs=debug to the URL and open the browser console.
 */
(function () {
  var DEBUG = /[?&]vdcs=debug/.test(location.search);
  function log() { if (DEBUG) console.log.apply(console, ['[vd-scroll]'].concat([].slice.call(arguments))); }

  function start() {
    if (!/^\/collections\/[^/]+\/?$/.test(location.pathname)) return log('not a collection path');

    var grid = findGrid(document);
    if (!grid) return log('grid not found');
    var sig = signature(grid);
    log('grid', sig, grid.children.length, 'cards');

    var pager = findPager(document, grid);
    var countNode = findCountText(document);
    var total = countNode ? +countNode.nodeValue.match(/of\s+(\d+)/i)[1] : null;
    var lastPage = pager ? maxPage(pager) : 1;
    log('pager', !!pager, 'lastPage', lastPage, 'total', total);
    if (lastPage <= 1 && !hasSoldOut(grid)) return log('single page, nothing to do');

    var PAGE = Math.max(grid.children.length, 1);
    var shown = {}, inStock = [], soldOut = [], visible = 0;
    var nextPage = 1, fetching = false, allFetched = false;

    // Seed from the server-rendered page 1.
    var current = +(new URLSearchParams(location.search).get('page') || 1);
    if (current !== 1) return log('deep page link, leaving as is');
    take(Array.prototype.slice.call(grid.children));
    nextPage = 2;
    if (nextPage > lastPage) allFetched = true;

    grid.innerHTML = '';
    if (pager) pager.style.display = 'none';

    var status = document.createElement('div');
    status.setAttribute('role', 'status');
    status.style.cssText = 'display:flex;justify-content:center;align-items:center;padding:24px 0;font-weight:600;font-size:14px;color:#313652';
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px';
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);
    sentinel.parentNode.insertBefore(status, sentinel.nextSibling);

    function take(cards) {
      cards.forEach(function (c) {
        var h = handleOf(c);
        if (!h || shown[h]) return;
        shown[h] = 1;
        (isSoldOut(c) ? soldOut : inStock).push(c);
      });
    }

    function fetchPage() {
      if (fetching || allFetched) return Promise.resolve();
      fetching = true;
      var p = new URLSearchParams(location.search);
      p.set('page', nextPage);
      var url = location.pathname + '?' + p.toString();
      log('fetch', url);
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector(sig) || findGrid(doc);
        var cards = g ? Array.prototype.slice.call(g.children).map(function (c) { return document.importNode(c, true); }) : [];
        log('page', nextPage, cards.length, 'cards');
        take(cards);
        nextPage++;
        if (!cards.length || nextPage > lastPage) allFetched = true;
        fetching = false;
      }).catch(function (e) { log('fetch failed', e); fetching = false; allFetched = true; });
    }

    // Queue order: in-stock cards, then (only once every page is fetched) sold-out cards.
    function queue() { return allFetched ? inStock.concat(soldOut) : inStock; }

    function render(n) {
      var q = queue(), added = [];
      while (visible < q.length && added.length < n) { grid.appendChild(q[visible]); added.push(q[visible]); visible++; }
      if (added.length) {
        document.dispatchEvent(new CustomEvent('vinod:products-appended', { detail: { items: added } }));
        if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init();
      }
      if (countNode && total) countNode.nodeValue = countNode.nodeValue.replace(/Showing\s+\d+\s*[–-]\s*\d+\s+of\s+\d+/i, 'Showing 1–' + visible + ' of ' + total);
      return added.length;
    }

    // Fill until `want` more cards are visible, fetching pages as needed.
    function more(want) {
      var need = want;
      function step() {
        need -= render(need);
        if (need <= 0) return Promise.resolve();
        if (allFetched) { need -= render(need); return Promise.resolve(); }
        return fetchPage().then(step);
      }
      status.innerHTML = '<span style="width:18px;height:18px;border:2px solid #d9dce3;border-top-color:#313652;border-radius:50%;display:inline-block;margin-right:10px;animation:vdspin .7s linear infinite"></span>Loading more products…';
      if (!document.getElementById('vdspin-kf')) { var st = document.createElement('style'); st.id = 'vdspin-kf'; st.textContent = '@keyframes vdspin{to{transform:rotate(360deg)}}'; document.head.appendChild(st); }
      var minShow = new Promise(function (r) { setTimeout(r, 500); });
      return Promise.all([step(), minShow]).then(function () {
        var done = allFetched && visible >= queue().length;
        status.textContent = done && visible > PAGE ? 'You’ve seen all ' + visible + ' products' : '';
        if (done) io.disconnect();
      });
    }

    var busy = false;
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting || busy) return;
      busy = true;
      more(PAGE).then(function () { busy = false; });
    }, { rootMargin: '0px 0px 150px 0px' });

    // Restore after Back from a product page.
    var key = 'vd-cs2:' + location.pathname + location.search;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    more(saved && saved.n > PAGE ? saved.n : PAGE).then(function () {
      if (saved) window.scrollTo(0, saved.y);
      io.observe(sentinel);
    });
    function save() { try { sessionStorage.setItem(key, JSON.stringify({ n: visible, y: window.scrollY })); } catch (e) {} }
    window.addEventListener('pagehide', save);
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a[href*="/products/"]')) save(); }, true);
  }

  function isSoldOut(card) {
    if (card.querySelector('[class*="sold-out" i], [class*="soldout" i], [data-sold-out]')) return true;
    var btn = card.querySelector('button[type="submit"], button[name="add"], .btn, button');
    if (btn && (btn.disabled || /sold\s*out|out of stock/i.test(btn.textContent))) return true;
    return /\bsold\s*out\b/i.test(card.textContent);
  }
  function hasSoldOut(grid) { return Array.prototype.some.call(grid.children, isSoldOut); }

  function findGrid(doc) {
    var forced = document.body.getAttribute('data-vd-grid');
    if (forced) return doc.querySelector(forced);
    var root = doc.querySelector('main') || doc.body, best = null, bestN = 0;
    root.querySelectorAll('ul, ol, div').forEach(function (el) {
      var kids = el.children, n = 0;
      if (kids.length < 2) return;
      for (var i = 0; i < kids.length; i++) if (kids[i].querySelector('a[href*="/products/"]')) n++;
      // Product grid = most cards, nearly every child is a card, and it isn't inside a slider.
      if (n > bestN && n >= kids.length * 0.8 && !el.closest('[class*="slider" i],[class*="carousel" i],[class*="swiper" i],[class*="flickity" i]')) { best = el; bestN = n; }
    });
    return best;
  }
  function signature(el) {
    if (el.id) return '#' + CSS.escape(el.id);
    var cls = Array.prototype.filter.call(el.classList, function (c) { return !/^(is-|js-)/.test(c); });
    var s = el.tagName.toLowerCase() + cls.map(function (c) { return '.' + CSS.escape(c); }).join('');
    var parent = el.parentElement;
    if (parent && parent.id) s = '#' + CSS.escape(parent.id) + ' > ' + s;
    return s;
  }
  function findPager(doc, grid) {
    var forced = document.body.getAttribute('data-vd-pager');
    if (forced) return doc.querySelector(forced);
    var links = (doc.querySelector('main') || doc.body).querySelectorAll('a[href*="page="]');
    if (!links.length) return null;
    var el = links[0].parentElement;
    while (el && el !== doc.body && el.querySelectorAll('a[href*="page="]').length < Math.min(links.length, 2)) el = el.parentElement;
    if (!el || el.contains(grid)) return links[0].parentElement;
    return el;
  }
  function maxPage(pager) {
    var m = 1;
    pager.querySelectorAll('a[href*="page="]').forEach(function (a) {
      var n = +((a.getAttribute('href').match(/[?&]page=(\d+)/) || [])[1] || 0);
      if (n > m) m = n;
    });
    return m;
  }
  function findCountText(doc) {
    var w = doc.createTreeWalker(doc.querySelector('main') || doc.body, NodeFilter.SHOW_TEXT);
    while (w.nextNode()) if (/Showing\s+\d+\s*[–-]\s*\d+\s+of\s+\d+/i.test(w.currentNode.nodeValue)) return w.currentNode;
    return null;
  }
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();